import { FieldArray, FormikProps } from 'formik';
import { InputField } from 'src/components/common/formFields';
import { componentSizeVariantsEnum } from 'src/constants';
import CoFounderDropDown from '../common/CoFounderDropDown';
import ToggleSwitch2 from 'src/components/common/toggle-switch-version2/ToggleSwitchV2';
import Label from 'src/components/common/formFields/label/Label';
import cx from './common.module.scss';
import { Button, Card, ProfilePicture, Typography } from 'src/components/common';
import { useAppSelector } from 'src/store/hooks';
import { TGetCompany } from 'src/services/apiEndpoint.types.ts';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { MdAdd } from 'react-icons/md';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

export default function TermGrowth(props: FormikProps<any>) {
    const { values, setFieldValue, touched, errors } = props;
    const navigate = useNavigate()
    const { paramValue } = useUrlParamValue();
    const { getIdentities } = useGetIdentity();
    const { loggedInUserType } = getIdentities();
    const id: string = paramValue({ paramName: 'id' }) as string;
    const type: string = paramValue({ paramName: 'type' }) as string;
    const {
        myCompany
    }: {
        myCompany: TGetCompany;
    } = useAppSelector((store) => store.company);

    function handleCreateCompany() {
        navigate(`/create-company?prev=/post-venture?id=${id}&type=${type}`)
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {/* Co-Founders Section */}
            <FieldArray name="coFounders">
                {({ push, remove }) => (
                    <>
                        {[...(values.coFounders.length > 0 ? [...values.coFounders] : [''])].map((coFounder: { userType?: string, id?: string }, index: number) => (
                            <CoFounderDropDown {...props} index={index} key={index} value={coFounder} handleAction={() => index === 0 ? push('') : remove(index)} />
                        ))}
                    </>
                )}
            </FieldArray>

            <InputField
                label='No. of Customers'
                id="noOfCustomers.number"
                component={
                    <ToggleSwitch2
                        id="noOfCustomers.hidden"
                        color={values.noOfCustomers.hidden ? '#fa4616' : '#bbb6b2'}
                        checked={values.noOfCustomers.hidden}
                        onChange={(e) => setFieldValue('noOfCustomers.hidden', e.target.checked)}
                    />
                }
                value={values.noOfCustomers.number}
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="No. of Customers"
                type="number"
                // required
                isTouched={typeof touched.noOfCustomers === 'boolean' ? touched.noOfCustomers : false}
                errorMessage={typeof errors?.noOfCustomers === 'string' ? errors.noOfCustomers : undefined}
            />

            <InputField
                label='Team Size'
                id="teamSize.number"
                // onChange={(e) => setFieldValue('temSize', { ...values.teamSize, number: e.target.value })}
                component={
                    <ToggleSwitch2
                        id="teamSize.hidden"
                        color={values.teamSize.hidden ? '#fa4616' : '#bbb6b2'}
                        checked={values.teamSize.hidden}
                        onChange={(e) => setFieldValue('teamSize.hidden', e.target.checked)}
                    />
                }
                value={values?.teamSize.number}
                variant={componentSizeVariantsEnum.SMALL}
                placeholder="Team Size"
                type="string"
                // required
                isTouched={typeof touched.teamSize === 'boolean' ? touched.teamSize : false}
                errorMessage={typeof errors?.teamSize === 'string' ? errors.teamSize : undefined}
            />
            {loggedInUserType !== 'Company' && <div className='input-field-component__labelBox'>
                <Label variant={componentSizeVariantsEnum.SMALL}>
                    <span>Link Your Company Page</span>
                </Label>
                <ToggleSwitch2
                    id="linkCompanyPage"
                    color={values.linkCompanyPage ? '#fa4616' : '#bbb6b2'}
                    checked={values.linkCompanyPage}
                    onChange={(e) => setFieldValue('linkCompanyPage', e.target.checked)}
                />
            </div>}
            {values.linkCompanyPage && <div className={`${cx.companyCard}`}>
                {myCompany.id && <>
                    <ProfilePicture url={myCompany.logo} fallback={myCompany.name?.[0]} />
                    <div className={cx.description}>
                        <Typography fontWeight='bold' variant='body-3'>
                            {myCompany.name}
                        </Typography>
                        <Typography fontWeight='regular' variant='caption' style={{ padding: '0', display: 'block' }}>
                            {myCompany.industry}
                        </Typography>
                    </div>
                </>}
                {!myCompany.id && (
                    <div className={`${cx.createcompanyPage} ${classNames('CreateCompanyNowCard')}`}>
                        <Typography as="p" variant="body-1" fontWeight="semiBold">
                            No company page found — let&apos;s create one!
                        </Typography>{' '}
                        <div className='svgBox' style={{ width: '75%' }}>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="33" viewBox="0 0 31 33" fill="none">
                                    <path d="M15.626 20.6804V17.0804M15.626 20.6804V24.2804M15.626 20.6804H26.426C28.4142 20.6804 30.026 19.0687 30.026 17.0804M15.626 20.6804H4.82595C2.83773 20.6804 1.22595 19.0687 1.22595 17.0804M30.026 17.0804V27.8804C30.026 29.8687 28.4142 31.4804 26.426 31.4804H4.82595C2.83773 31.4804 1.22595 29.8687 1.22595 27.8804V17.0804M30.026 17.0804V9.88043C30.026 7.89221 28.4142 6.28043 26.426 6.28043H4.82595C2.83773 6.28043 1.22595 7.89221 1.22595 9.88043V17.0804M21.026 6.28043V4.48043C21.026 2.49221 19.4142 0.880432 17.426 0.880432H13.826C11.8377 0.880432 10.226 2.49221 10.226 4.48043V6.28043" stroke="white" strokeWidth="1.62" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        </div>
                        <Button size="extraSmall" variant="secondary" style={{ width: 'auto' }} onClick={handleCreateCompany}>
                            Get Started
                        </Button>
                    </div>
                )}
            </div>}
        </div>
    )
}
